/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component, Input } from '@angular/core';
import { IApplicationLog } from 'generated-types';
import { DurationProperty } from '../../logs.types';

import './log-duration-bar.component.less';
import { LogsDurationDetailService } from '../../services/logs-duration-detail.service';

/**
 * @description
 *     For application logs only.
 *     Render a bar to indicate the time duration of waf, client, server, app respones, and data transfer in a logs list
 *     page.
 * @author Shanmukha Sarath Kondiparthi, Zhiqian Liu
 */
@Component({
    selector: 'log-duration-bar',
    templateUrl: 'log-duration-bar.component.html',
})
export class LogDurationBarComponent {
    @Input()
    public largestTotalTime: number;

    @Input()
    public log: IApplicationLog;

    @Input()
    public filter: DurationProperty;

    public DurationProperty = DurationProperty;

    public readonly percentage = {
        [DurationProperty.waf]: 0,
        [DurationProperty.clientRtt]: 0,
        [DurationProperty.serverRtt]: 0,
        [DurationProperty.appResponseTime]: 0,
        [DurationProperty.dataTransferTime]: 0,
    };

    constructor(private readonly logsDurationDetailService: LogsDurationDetailService) {}

    public ngOnChanges(): void {
        const { log, largestTotalTime } = this;

        this.percentage[DurationProperty.waf] =
            Number(this.logsDurationDetailService.getWafTime(log)) * 100 / largestTotalTime;
        this.percentage[DurationProperty.clientRtt] =
            Number(log.client_rtt) * 100 / largestTotalTime;
        this.percentage[DurationProperty.serverRtt] =
            Number(log.server_rtt) * 100 / largestTotalTime;
        this.percentage[DurationProperty.appResponseTime] =
            Number(log.app_response_time) * 100 / largestTotalTime;
        this.percentage[DurationProperty.dataTransferTime] =
            Number(log.data_transfer_time) * 100 / largestTotalTime;
    }
}
